import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { DEFAULT_DATE_FORMAT_CS } from "@constants";

dayjs.extend(customParseFormat);

export const isValidEmail = (email: string): boolean => {
  if (!email) return false;
  if (email.length > 254) return false;
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

  if (!regex.test(email)) return false;

  const [local, domain] = email.split("@");

  if (!local || !domain) return false;
  if (local.startsWith(".") || local.endsWith(".")) return false;
  if (domain.includes("..")) return false;

  return true;
};

export const isValidDate = (dateString: string): boolean => {
  if (!dateString) return false;

  return dayjs(dateString, DEFAULT_DATE_FORMAT_CS, true).isValid();
};
